const convertMillisecondsToMinutes = (millis) => Math.floor(millis / 60000)

export default convertMillisecondsToMinutes
